import React from 'react';

// import Skeleton, { Table } from '@nejcm/react-skeleton';



import Skeleton from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';

// import { useLocation } from 'react-router-dom';

// import styled from 'styled-components';

import PortletBody from '../../app/components/portlet/PortletBody';



const AnalyticSkeleton = ({ cols, show, customeColWidth=200 }) => {

  return (
    <>
      <PortletBody className='p-0 px-1 mx-2'>
      <Skeleton height={'80px'} width={'100%'} className="mt-0 mx-auto" />
      </PortletBody>

      <PortletBody className='mt-4 mx-2'>
      <Skeleton height={'70vh'} width={'100%'} className="mt-0 mx-auto" />
      </PortletBody>

    </>

  );

};


export default AnalyticSkeleton;

